import React from 'react'
import { Link } from 'react-router-dom'
import Vector from '../../assets/images/Vector.svg';
import SideMenu from '../../components/ProfileSideMenu/SideMenu'
import Navbar from '../../components/nav/NavBar'
import Footer from '../../components/footer/Footer'

export default function ProfileSettings() {


    const email = localStorage.getItem('email');
    const userData = JSON.parse(localStorage.getItem('userData'));

    return (
        <>
            <Navbar />
            <div className='favourit-page-holder'>
                <div className='side-menu-component-holder'>
                    <SideMenu />
                </div>
                <div className='favourite-component-holder'>
                    <div className='page-name-holder'>Profile</div>
                    <div className='info-box-holder'>
                        <div className='info-title-holder title-line'>
                            <div className='box-title'>General Information</div>

                            <Link className='edit' to={'/edit-info'}>
                                <p className='edit-link'>Edit</p>
                                <img className='edit-icon' src={Vector} alt='arrow-icon' />
                            </Link>

                        </div>
                        <div className='info-holder'>
                            <div className='info info-for-name'>
                                <div className='info-title'>First name</div>
                                <div className='info-data'>{userData.firstName}</div>
                            </div>
                            <div className='info '>
                                <div className='info-title'>Last name</div>
                                <div className='info-data'>{userData.lastName}</div>
                            </div>
                            {/* <div className='info '>
                                <div className='info-title'>Gender</div>
                                <div className='info-data'></div>
                            </div> */}
                        </div>
                    </div>

                    <div className='info-box-holder'>
                        <div className='info-title-holder title-line'>
                            <div className='box-title'>Email</div>
                        </div>
                        <div className='info-holder'>
                            <div className='info '>
                                <div className='info-title'>Email</div>
                                <div className='info-data'>{email}</div>
                            </div>
                        </div>
                    </div>

                    {/* <div className='info-box-holder'>
                        <div className='info-title-holder title-line'>
                            <div className='box-title'>Phone number</div>

                            <Link className='edit' to={'#'}>
                                <p className='edit-link'>Edit</p>
                                <img className='edit-icon' src={Vector} alt='arrow-icon' />
                            </Link>


                        </div>
                        <div className='info-holder'>
                            <div className='info '>
                                <div className='info-title'>Phone number</div>
                                <div className='info-data'></div>
                            </div>
                        </div>

                    </div> */}
                    <div className='info-box-password'>
                        <div className='info-title-holder'>
                            <div className='box-title'>Password</div>

                            <Link className='edit' to={'/edit-password'}>
                                <p className='edit-link'>Edit</p>
                                <img className='edit-icon' src={Vector} alt='arrow-icon' />
                            </Link>

                        </div>
                    </div>

                </div>
            </div>
            <Footer />
        </>


    )
}
